import { render, staticRenderFns } from "./redirect.vue?vue&type=template&id=542b4ef0&"
import script from "./redirect.vue?vue&type=script&lang=ts&"
export * from "./redirect.vue?vue&type=script&lang=ts&"
import style0 from "./redirect.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports